import styled from 'styled-components';

import { TableWrapper as TableWrapperComponent } from '@pages/StaticPlaceholder.styled';

export const TableWrapper = styled(TableWrapperComponent)`
    margin-top: 16px;
`;
